import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Modal, { DEFAULT_CONFIRM_FUNCTION } from '../Modal';

export default function SideSheet({
  size = 'xs', // "xs" | "md" | "lg" | "xl" | "2xl"
  isOpen = false,
  title = '',
  footerInfo = '',
  onEnter = () => {},
  onExit = () => {},
  onOpened = () => {},
  onClose = () => {},
  onClosed = () => {},
  onConfirm = DEFAULT_CONFIRM_FUNCTION,
  isProcessing = false,
  isConfirmDisabled = false,
  hideCancelButton = false,
  confirmBtnVariant = undefined,
  confirmBtnText = undefined,
  confirmBtnProcessingText = undefined,
  cancelBtnText = undefined,
  className = '',
  contentClassName = '',
  headerClassName = '',
  titleClassName = '',
  footerClassName = '',
  footerInfoClassName = '',
  bodyClassName = '',
  children = null,
  onBackBtnClick = () => {},
  ...reactstrapModalProps
}) {
  const showFooter =
    onConfirm &&
    onConfirm !== DEFAULT_CONFIRM_FUNCTION &&
    onConfirm instanceof Function;

  return (
    <Modal
      size={size}
      isOpen={isOpen}
      isProcessing={isProcessing}
      zIndex={10000}
      onEnter={onEnter}
      onExit={onExit}
      onOpened={onOpened}
      onClose={onClose}
      onClosed={onClosed}
      className={cn(styles.container, className)}
      modalClassName={styles.modal}
      contentClassName={cn(styles.content, contentClassName)}
      modalTransition={{
        timeout: 300, // milliseconds
        appear: false,
        baseClass: styles.modal,
        baseClassActive: styles.show
      }}
      {...reactstrapModalProps}
    >
      <Modal.Header
        title={title}
        titleWeight="normal"
        hideCrossBtn={false}
        className={cn(styles.header, headerClassName)}
        titleClassName={cn(styles.title, titleClassName)}
      />
      <Modal.Body className={cn(styles.body, bodyClassName)}>
        {children}
      </Modal.Body>
      {showFooter && (
        <Modal.Footer
          onConfirm={onConfirm}
          btnSize="md"
          isConfirmDisabled={isConfirmDisabled}
          hideCancelBtn={hideCancelButton}
          cancelBtnText={cancelBtnText || 'Cancel'}
          confirmBtnText={confirmBtnText || 'Confirm'}
          confirmBtnVariant={confirmBtnVariant || 'primary'}
          className={cn(styles.footer, footerClassName)}
        >
          <div className={cn(styles.footerText, footerInfoClassName)}>
            {footerInfo}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
}
